var _path, _circle, _g, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconPresidente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 42,
    viewBox: "0 0 55 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50315 16.1277C4.80783 11.868 8.09562 8 12.4117 8H41.4941C45.6872 8 48.9396 11.6613 48.4453 15.8252L46.4272 32.8252C46.0091 36.3473 43.0228 39 39.476 39H15.1866C11.7559 39 8.83075 36.5136 8.27806 33.1277L5.50315 16.1277Z",
    fill: "white",
    stroke: "#DDAF33",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 10,
    r: 9,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9537 19.6532C24.7613 19.7257 22.6521 20.2372 20.6763 21.1764C20.499 21.2607 20.3132 21.3056 20.1287 21.3149C15.8724 23.4391 12.639 27.4226 11.6249 32.2937C11.5311 32.7438 11.6427 33.2053 11.931 33.5597C12.0979 33.765 12.4702 34.1094 13.0872 34.1094H23.8125H30.8867H41.6121C42.2291 34.1094 42.6013 33.765 42.7682 33.5597C43.0565 33.2053 43.1681 32.7438 43.0744 32.2937C42.0603 27.4226 38.8268 23.4391 34.5705 21.3149C34.386 21.3056 34.2002 21.2607 34.0229 21.1764C32.0471 20.2372 29.9379 19.7257 27.7455 19.6532C27.6633 19.6552 27.5808 19.6562 27.4981 19.6562C27.4485 19.6562 27.399 19.6559 27.3496 19.6551C27.3002 19.6559 27.2507 19.6562 27.2011 19.6562C27.1184 19.6562 27.0359 19.6552 26.9537 19.6532ZM27.3496 0.00110418C27.3002 0.000368925 27.2507 0 27.2011 0C21.7819 0 17.373 4.40893 17.373 9.82812C17.373 13.0442 18.9259 15.9045 21.3211 17.6986C19.1265 18.4212 17.0673 19.5454 15.265 21.0279C11.9602 23.7463 9.66235 27.538 8.79494 31.7046C8.52308 33.0101 8.84878 34.3511 9.68837 35.3835C10.5238 36.4108 11.7627 37 13.0872 37H23.8125H30.8867H41.6121C42.9365 37 44.1754 36.4108 45.0109 35.3835C45.8504 34.3511 46.1761 33.0101 45.9043 31.7046C45.0369 27.538 42.739 23.7463 39.4342 21.0279C37.6319 19.5454 35.5727 18.4212 33.3781 17.6986C35.7734 15.9045 37.3262 13.0442 37.3262 9.82812C37.3262 4.40893 32.9173 0 27.4981 0C27.4485 0 27.399 0.000368926 27.3496 0.00110418ZM27.3496 2.89219C23.5925 2.97146 20.5606 6.05235 20.5606 9.82812C20.5606 13.5175 23.4553 16.5434 27.0928 16.7539C27.1289 16.7537 27.165 16.7536 27.2011 16.7536C27.2507 16.7536 27.3002 16.7537 27.3496 16.7541C27.3991 16.7537 27.4485 16.7536 27.4981 16.7536C27.5342 16.7536 27.5703 16.7537 27.6064 16.7539C31.2439 16.5434 34.1386 13.5175 34.1386 9.82812C34.1386 6.05235 31.1067 2.97146 27.3496 2.89219Z",
    fill: "#D59B00"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2617 24.5539L24.4763 19.53C24.6933 18.6323 25.4967 18 26.4203 18H28.0658C29.0475 18 29.8841 18.7125 30.0403 19.6818L30.8537 24.7284C30.9465 25.3047 30.783 25.8928 30.4059 26.3385L28.0143 29.165C27.6347 29.6135 26.952 29.6397 26.5392 29.2216L23.7824 26.4289C23.296 25.9362 23.099 25.2269 23.2617 24.5539Z",
    stroke: "#DDAF33",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06721 36.8025C2.16125 36.3357 2.57136 36 3.04751 36H51.4914C51.9379 36 52.3303 36.296 52.4529 36.7253L53.3101 39.7253C53.4926 40.3641 53.0129 41 52.3485 41H2.44312C1.81149 41 1.33807 40.4217 1.46281 39.8025L2.06721 36.8025Z",
    fill: "white",
    stroke: "#DDAF33",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 33,
    width: 49,
    height: 2,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconPresidente);
export default __webpack_public_path__ + "static/media/menu-icon-presidente.690b6fe4f693e642f270b56ee446f6fb.svg";
export { ForwardRef as ReactComponent };